import {
  Box,
  Button,
  CircularProgress,
  Container,
  Typography,
} from '@mui/material';
import React, { useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import AuthWrapper from '../../layout/auth/auth-wrapper';
import { activateUser } from '../../modules/users';

const ConfirmationPage = () => {
  const [status, setStatus] = useState('idle');
  const [message, setMessage] = useState('');
  const navigate = useNavigate();
  const location = useLocation();

  const getTokenFromURL = () => {
    const params = new URLSearchParams(location.search);
    return params.get('confirmation_token');
  };

  const handleConfirm = async () => {
    const token = getTokenFromURL();
    if (token) {
      verifyToken(token);
    }
  };

  const verifyToken = async (token) => {
    setStatus('loading');
    try {
      const user = { token };
      await activateUser(user);
      setStatus('success');
      setMessage('Email confirmed successfully! Please login to continue.');
    } catch (error) {
      setStatus('error');
      setMessage(
        error.message || 'Email verification failed. Please try again.'
      );
    }
  };

  return (
    <AuthWrapper>
      <Container maxWidth="sm" sx={{ textAlign: 'center', mt: 5 }}>
        {status === 'loading' && (
          <>
            <CircularProgress />
            <Typography variant="h6" sx={{ mt: 2 }}>
              Verifying your details...
            </Typography>
          </>
        )}

        {status === 'error' && (
          <>
            <Typography variant="h4" color="error" sx={{ mt: 2, mb: 1 }}>
              Email Verification Failed
            </Typography>
            <Typography variant="body1" sx={{ mb: 3 }}>
              {message}
            </Typography>
            <Button variant="contained" onClick={() => navigate('/login')}>
              Go to Login
            </Button>
          </>
        )}

        {status === 'success' && (
          <>
            <Typography variant="h4" color="primary" sx={{ mt: 2, mb: 1 }}>
              Success!
            </Typography>
            <Typography variant="body1" sx={{ mb: 3 }}>
              {message}
            </Typography>
            <Button variant="contained" onClick={() => navigate('/login')}>
              Go to Login
            </Button>
          </>
        )}
        {status === 'idle' && (
          <>
            <Typography variant="h4" color="primary" sx={{ mt: 2, mb: 1 }}>
              Confirm Your Email Address
            </Typography>
            <Typography variant="body1" sx={{ mb: 3 }}>
              To complete your registration, please confirm your email address
              by clicking the button below. Once confirmed, you'll be redirected
              to the login page.
            </Typography>
            <Box>
              <Button variant="contained" onClick={handleConfirm}>
                Confirm Email
              </Button>
            </Box>
          </>
        )}
      </Container>
    </AuthWrapper>
  );
};

export default ConfirmationPage;
